import type { PaymentProviderBase } from "../payment-provider-base";

const stripePaymentTypes = [
    "stripe_payment_request_button", // apple/google/microsoft-pay etc..
    "stripe_card",
    "stripe_preselected_card",
] as const;
type StripePaymentType = (typeof stripePaymentTypes)[number];
const stripePaymentProvider: PaymentProviderBase<"STRIPE", StripePaymentType> =
    {
        _type: "STRIPE-PAYMENT_PROVIDER",
        name: "STRIPE",
        displayName: "Stripe",
        paymentTypes: stripePaymentTypes,
    };

type StripePaymentProvider = typeof stripePaymentProvider;

export type { StripePaymentType, StripePaymentProvider };
export { stripePaymentTypes, stripePaymentProvider };
